import { SvgIcon } from '@mui/material'
import { User } from '@firebase/auth'
import { env } from 'config'
import {
  hasSignInProvider,
  MICROSOFT_PROVIDER_ID,
  OAuthProviderId,
} from './auth'

export const MicrosoftIcon = () => (
  <SvgIcon viewBox="0 0 21 21" fontSize="small">
    <rect x="1" y="1" width="9" height="9" fill="#F25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
    <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
    <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
  </SvgIcon>
)

export interface OAuthProvider {
  providerId: OAuthProviderId
  // A brand name, the same in every language
  name: string
  Icon: () => JSX.Element
}

// The providers enabled in this environment
export const OAUTH_PROVIDERS: OAuthProvider[] = [
  ...(!env.hideMicrosoftAuth
    ? [
        {
          providerId: MICROSOFT_PROVIDER_ID,
          name: 'Microsoft',
          Icon: MicrosoftIcon,
        },
      ]
    : []),
]

// Like on the sign-in page, an account with a provider signs in only with it
export const getUserOAuthProvider = (user: User | null | undefined) =>
  OAUTH_PROVIDERS.find(({ providerId }) => hasSignInProvider(user, providerId))
